import moment from 'moment';
import {ReplaySubject, Subject} from 'rxjs';


export class FieldsInterventionsPageRequest {
  get isLoading(): boolean {
    return this._isLoading;
  }

  set isLoading(value: boolean) {
    this._isLoading = value;
  }

  private _submitSubject = new ReplaySubject<void>(1);
  submit$ = this._submitSubject.asObservable();

  private _isLoading = false;

  // Data
  isToday: boolean;
  from: Date;
  to: Date;
  currentFilter = 2;
  interventionType: string | null = null; // null = all, 'trailer' = Auto, 'reconstructed' = Auto (A valider)
  showAllPending: boolean = false; // Flag to show all pending interventions without date limits

  constructor() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
  }

  submit() {
    this._submitSubject.next();
  }

  loading(isLoading: boolean) {
  }
}
